// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__FO7bQ","right":"Footer_right__3qB9C","buttons":"Footer_buttons__l3JAy"};